import React, { useState, useRef, useEffect } from 'react';
import { shallowEqual, useSelector } from 'react-redux';
import { Button } from 'react-bootstrap';
import './Recorder.css';
import { UploadPhoto } from '../s3Func/s3Upload';
import Webcam from 'react-webcam';
import { Buffer } from 'buffer';
import countdownSound from './../PhotoTime/count_down_beep.m4a';
import loading from './../loading-gif-png-5.gif';

window.Buffer = Buffer;

export default function Recorder(props) {
  const { login } = useSelector((state) => state.loginReducer, shallowEqual);
  const recordBtn = React.useRef();
  const webcamRef = React.useRef(null);
  const audioRef = React.useRef(null);
  const mediaRecorderRef = React.useRef(null);
  const [, forceUpdate] = useState();
  const [capturing, setCapturing] = React.useState(false);
  const [notCapturing, setNotCapturing] = React.useState(false);
  const [recordedChunks, setRecordedChunks] = React.useState([]);
  const [touchButton, setTouchButton] = React.useState(false);
  const [dataUri, setDataUri] = useState('');
  const text = props.outputText;
  const [contin, setContin] = useState(false);
  const [pause, setPause] = useState(false);
  const [playBtn, setPlayBtn] = useState(false);
  const cdSound = new Audio(countdownSound);
  const timer = useRef();
  const generateImageUrl = (baseUrl) => login.cloudFront + baseUrl + login.cookie;

  const confirmIcon = generateImageUrl('images/Module1Images/check_button_small.png');
  const cancelIcon = generateImageUrl('images/Module1Images/x_button.png');
  const playButton = generateImageUrl('images/Images/Video play.png');
  const pauseButton = generateImageUrl('images/Images/pause.png');
  const [Exit] = useState(generateImageUrl('images/Images/close.png'));

  const [waiting, setWaiting] = useState(false);

    const [videoConstraints, setVideoConstraints] = useState({
      width: 391,
      height: 580,
    });

  function isIOS() {
    return [
      'iPad Simulator',
      'iPhone Simulator',
      'iPod Simulator',
      'iPad',
      'iPhone',
      'iPod'
    ].includes(navigator.platform)
    // iPad on iOS 13 detection
    || (navigator.userAgent.includes("Mac") && "ontouchend" in document)
  }
  
  /** 
   * On some of the iOS devices, the video gets too big so that Safari fails to process the file and returns 0-byted one without failing (which is undocumented and, obviously, an error).
   * As a workaround, we reduce the quality of a video in the native recording API (which is used by the `videojs-record` and `RecordRTC` internally) so that it won't get to this size.
   * 
   * TODO: remove it when https://bugs.webkit.org/show_bug.cgi?id=85851 is resolved by Apple.
   */
  if (isIOS()) {
    
    const DefaultMediaRecorder = MediaRecorder;
    const kb = 8 * 1024;
    const preferredBitRatePerSecond = 100 * kb;
    MediaRecorder = class extends DefaultMediaRecorder {
      constructor(stream, options) {
        super(stream, {
          ...options, 
          audioBitsPerSecond: preferredBitRatePerSecond,
          videoBitsPerSecond: preferredBitRatePerSecond,
        });
      }
    }
  }

  function isLandscape() {
    return window.matchMedia("(orientation: landscape)").matches;
  }

  const handleDataAvailable = React.useCallback(
    ({ data }) => {
      if (data.size > 0) {
        setRecordedChunks((prev) => prev.concat(data));
      }
    },
    [setRecordedChunks]
  );

  const handleStopCaptureClick = () => {
    mediaRecorderRef.current.stop();
    mediaRecorderRef.current.addEventListener(
      'dataavailable',
      handleDataAvailable
    );
    setCapturing(false);
    setNotCapturing(false);
    setContin(true);
    clearTimeout(timer.current);
  }

  const handleStartCaptureClick = async () => {
    setCapturing(false);
    setNotCapturing(true);
    await sleep(10);
    recordBtn.current.disabled = true;
    recordBtn.current.style.opacity = 0;
    mediaRecorderRef.current = new MediaRecorder(webcamRef.current.stream, {
      mimeType: isIOS() ? 'video/mp4' : 'video/webm',
    });
    mediaRecorderRef.current.start();
    timer.current = setTimeout(() => handleStopCaptureClick(), 60000);
    await sleep(2000);
    recordBtn.current.disabled = false;
    recordBtn.current.style.opacity = 1;
  }

  function uploadVid() {
    if (recordedChunks.length) {
      const newBlob = new Blob(recordedChunks, {
        type: 'video/mp4',
      });
      const url = URL.createObjectURL(newBlob);
      setRecordedChunks([]);
      return url;
    }
  }

  // if(getOS() === 'iOS' || getOS() === 'Android'){
  //   videoConstraints = {
  //     height: 391,
  //     width: 580,
  //     facingMode: "user",
  //   };
  // }
  // else{
  //   videoConstraints = {
  //     width: 391,
  //     height: 580,
  //     facingMode: "user",
  //   };
  // }

  function sleep(ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  }

  useEffect(() => {
    sleep(2000).then(() => {
      setCapturing(true)
    });
  }, []);

  return waiting ? 
  (
    <div
      id='recordpage'
      style={{ backgroundImage: `url(${props.background})` }}
    >
      < img id='loading' src={loading} />
    </div>
  )
  : dataUri ? 
  (
    <div
      id='recordpage'
      style={{ backgroundImage: `url(${props.background})` }}
    >
      <img
        className='back-btn-ftb'
        alt='back button'
        src={Exit}
        onClick={() => {
          props.close(false);
        }}
      ></img>
      {touchButton && (
        <audio
          autoPlay
          onEnded={() => {
            setTouchButton(false);
          }}
        >
          <source
            src={
              generateImageUrl('media/Module1Videos/touch_button.mp3')
            }
            type='audio/mp3'
          />
        </audio>
      )}
      <div id='border1'>
        <h4 id='cameraText'>Use this video?</h4>
        <video
          id='record-video'
          autoPlay
          src={dataUri}
          onEnded={() => {
            setPause(false);
            setPlayBtn(true);
            document.getElementById('pauseButton').src = playButton;
          }}
          onError={() => {
            setPause(false);
            setPlayBtn(true);
            document.getElementById('pauseButton').src = playButton;
          }}
          playsInline
        />
        <img
          alt='cancel button'
          className='cancel'
          style={{
            width: '75px',
            height: '75px',
            cursor: 'pointer',
          }}
          src={cancelIcon}
          onClick={() => {
            setDataUri(null);
            sleep(2000).then(() => {
              setCapturing(true)
            });
            setContin(false);
            setNotCapturing(false);
            setPlayBtn(false);
            forceUpdate();
          }}
        />
        {playBtn && (
          <img
            alt='play button'
            id='pauseButton'
            style={{
              left: '50%',
              marginLeft: '-37.5px',
              position: 'absolute',
              bottom: '1vh',
              width: '75px',
              height: '75px',
              cursor: 'pointer',
            }}
            src={playButton}
            onClick={() => {
              if (pause) {
                document.getElementById('record-video').pause();
                document.getElementById('pauseButton').src = playButton;
                setPause(!pause);
              } else {
                document.getElementById('record-video').play();
                document.getElementById('pauseButton').src = pauseButton;
                setPause(!pause);
              }
            }}
          />
        )}
        <img
          alt='confirm button'
          className='confirm'
          style={{
            width: '75px',
            height: '75px',
            cursor: 'pointer',
          }}
          src={confirmIcon}
          onClick={ async () => {
            setWaiting(true);
            const result = await UploadPhoto(dataUri, 'userfiles', props.name, 'video/mp4', login.studentid);
            if (result === 200){
              props.setDisplayCelebrateAfterVideo(true);
              props.setDisplayCelebrateRecord(false);
              setWaiting(false);
            }
            else{
              window.alert('Whoops, failed to upload. It looks like the internet connection was lost. Please try again after login.');
              window.location.reload(false);            
            }
          }}
        />
      </div>
    </div>
  ) : (
    <>
      <div
        id='recordpage'
        style={{ backgroundImage: `url(${props.background})` }}
      >
        <img
          className='back-btn-ftb'
          alt='back button'
          src={Exit}
          onClick={() => {
            props.close(false);
          }}
        ></img>
        <div id='border1'>
          {props.voice1 && (
            <audio autoPlay ref={audioRef}>
              <source src={props.voice1}></source>
            </audio>
          )}
          <h4 id='cameraText'> {text} </h4>
          <Webcam
            id='record-video'
            audio={true}
            muted
            videoConstraints={(isIOS() && !isLandscape()) ? {height: 391, width: 580} : videoConstraints}
            ref={webcamRef}
          />
          {notCapturing && (
            <button
              className='stopButton'
              ref={recordBtn}
              onClick={() => {
                handleStopCaptureClick();
              }}
            ></button>
          )}
          {capturing && (
            <button
              className='recordButton'
              onClick={() => {
                cdSound.play();
                if (props.voice1) {
                  audioRef.current.pause();
                }
                sleep(500).then(() => {
                  handleStartCaptureClick();
                });
              }}
            ></button>
          )}
          {contin && (
            <Button
              className='continueButton'
              onClick={() => {
                setDataUri(uploadVid());
              }}
            >
              Continue
            </Button>
          )}
        </div>
      </div>
    </>
  );
}
